import { DeviceManager, DeviceProtocol } from '../device'
import { fakeSocket } from '@hid/fakesocket/fakesocket.ts'
import { DialogType, enableDialog } from '@/components/cdialog/dialog'
import { DriverSocketMsgType } from '@libs/types/message'
import { CurrentDevice, DeviceChange, DeviceChangeType, WatchDevice } from '@libs/types/response'
import { deviceZone, IKeyZone } from '../device_zone'
import { powerSet } from '../driver/power_set'
import { SocketService } from '@libs/socket/socket_service'
import { errorMessages } from '../error_messages'
import i18n from '@/languages/i18n'
import { baseSet } from '../driver/base_set'

const { t } = i18n.global

export class WebDriver {
    socketService: SocketService = new SocketService({
        autoReconnect: false
    })
    constructor() {
        this.initSocketConnection()
    }

    private initSocketConnection() {
        this.socketService.connect(fakeSocket)
        this.socketService.setMsgErrorCallback(this.showErrorNotification)
        this.socketService.setEventHandlers({
            onOpen: () => this.handleOpen()
        })
    }

    private showErrorNotification(errMessage: string) {
        const errMsg = errorMessages[errMessage] ? t(errorMessages[errMessage].i18n) : errMessage
        enableDialog(errMsg, DialogType.notice, false)
    }

    private handleOpen() {
        enableDialog('', DialogType.notice)
        this.askDefineZones()
        this.askCurrentDevices()
        this.handleNotificationMsgs()
    }
    private async askCurrentDevices() {
        const devices = await this.socketService.askType<CurrentDevice[]>(DriverSocketMsgType.MTCurrentDevices)
        if (!devices) {
            return
        }
        DeviceManager.instance.state.webDeviceList = devices
    }

    private askDefineZones() {
        this.socketService.askType<IKeyZone>(DriverSocketMsgType.MTGetKeyZones).then((res) => {
            console.log('res', res)
            deviceZone.askDefineZones(res, DeviceProtocol.hid_web)
        })
    }

    handleNotificationMsgs() {
        this.socketService.setHandler(
            DriverSocketMsgType.MSWatchDevice,
            (res: WatchDevice) => {
                this.changeDevice(res)
            },
            (err: string) => {
                console.log('MSWatchDevice:', err)
            }
        )
        this.socketService.setHandler(DriverSocketMsgType.MSRequestDevice, (_res: WatchDevice) => {
            this.askCurrentDevices()
        })
        this.socketService.setHandler(DriverSocketMsgType.MSDeviceChange, (res: DeviceChange) => {
            switch (res.ChangeType) {
                case DeviceChangeType.dpi:
                    baseSet.changeMouseDpi(res.ChangeData.DpiIndex)
                    break
                case DeviceChangeType.power:
                    powerSet.getPowerData()
                    break
                case DeviceChangeType.status:
                    DeviceManager.instance.state.deviceStatus = res.State
                    break
            }
        })
    }

    changeDevice(_: WatchDevice) {
        DeviceManager.instance.resetState()
        this.askCurrentDevices()
    }
}
